<template>
  <section class="page-hero">
    <div class="page-hero-inner">
      <nav v-if="showBreadcrumb" class="breadcrumb" aria-label="Breadcrumb">
        <a href="/">Home</a>
        <span aria-hidden="true">›</span>
        <span class="breadcrumb-current" aria-current="page">{{ title }}</span>
      </nav>
      <h1>{{ title }}</h1>
      <p>{{ subtitle }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "DeliveryHero",
  props: {
    title: {
      type: String,
      default: "Shipping Info",
    },
    subtitle: {
      type: String,
      default:
        "Fast shipping, reliable carriers, and transparent policies — so your order arrives exactly as expected.",
    },
    showBreadcrumb: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
